import { FirestoreDataConverter, DocumentData, QueryDocumentSnapshot, SnapshotOptions } from "firebase/firestore";

export const TICKET_CLICK_COUNT_PATH = "events/click/tickets";

export type TicketClickCountType = {
  id: string;
  createTime: number;
  updateTime: number;
  brandId: string;
  storeId: string;
  ticketId: string;
  influencerId: string;
  from: "home" | "storeDetail";
};

export const ticketClickCountConverter: FirestoreDataConverter<TicketClickCountType> = {
  toFirestore(event: TicketClickCountType): DocumentData {
    return {
      id: event.id,
      createTime: event.createTime,
      updateTime: event.updateTime,
      brandId: event.brandId,
      storeId: event.storeId,
      ticketId: event.ticketId,
      influencerId: event.influencerId,
      from: event.from,
    };
  },
  fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): TicketClickCountType {
    const data = snapshot.data(options);
    return {
      id: snapshot.id,
      createTime: data.createTime,
      updateTime: data.updateTime,
      brandId: data.brandId,
      storeId: data.storeId,
      ticketId: data.ticketId,
      influencerId: data.influencerId,
      from: data.from,
    };
  },
};
